import { useMemo } from "react";
import { UploadDocumentFieldFormik } from "../../../../renters/components/forms/fields/UploadDocumentFieldFormik";
import { DeliveredDetailsImage } from "../vehicle-delivered/CardDeliveredDetails/DeliveredDetails.Image";

type VehiclesHistoricalRowProps = {
  name: string
  initialData: { type: string, content: string, }
  prefix: string
  vehicleId: string

}
export function DetailsImageVehicleRow(props: VehiclesHistoricalRowProps) {
  const vehicle = props.vehicleId
  const pathToUpload = useMemo(() => `vehicles/${vehicle}/${props.prefix}`, [vehicle, props.prefix])

  return (
    <div className="flex flex-row">
      <UploadDocumentFieldFormik name={`${props.name}.content`} pathToUpload={pathToUpload}>
        {({ src, onNewFile, onRemoveClick }) => (
          <DeliveredDetailsImage
            src={src}
            onNewFile={onNewFile}
            onRemoveClick={onRemoveClick}
          />
        )}
      </UploadDocumentFieldFormik>
    </div>
  )
}